export default "__VITE_ASSET__Cyj3J3hK__"